export default __webpack_public_path__ + "static/media/000_wurz.477a8d9a.png";